import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';
import { bind } from 'app/_decorators/bind.decorator';
import { ProductResource } from 'app/_resources/product.resource';
import { AuctionsOverviewService } from 'app/_services/auctions-overview.service';
import { FileService } from 'app/_services/file.service';
import { ProductUploadWizardService } from 'app/_services/product-upload-wizard.service';
import { UtilService } from 'app/_services/util.service';

class ProductUploadWizardSummaryComponentCtrl implements ng.IController {
    public wizardCtrl: mgoAngularWizard.Wizard<any>;

    public PERIOD_TYPE;
    public ui = {};
    public editCompetition = false;
    public transferDataForPaginatedTable = [];
    public competitionError: boolean;
    public competitionErrorMessage = [];
    public competitionMatchErrorMessage = [];
    public editExistingCompetition: boolean;
    public competitionMatchError: boolean;
    public editCompetitionIndex: any;
    public competition = {
        constraint: {
            value: null,
            unit: null
        },
        offerIds: []
    };

    constructor(
        private fileService: FileService,
        private auctionsOverviewService: AuctionsOverviewService,
        private productUploadWizardService: ProductUploadWizardService,
        private productResource: ProductResource,
        private utilService: UtilService,
        private $window: ng.IWindowService
    ) {}

    $onInit(): void {
        this.PERIOD_TYPE = this.auctionsOverviewService.PERIOD_TYPE;

        if (!this.wizardCtrl.context.transferData) {
            this.wizardCtrl.context.transferData = [];
        }
        if (!this.wizardCtrl.context.competitions) {
            this.wizardCtrl.context.competitions = [];
        }

        if (
            this.isNewProductSet(this.wizardCtrl.context.data.wizardGuid) &&
            this.wizardCtrl.context.data.products
        ) {
            this.wizardCtrl.context.transferData.push(
                this.wizardCtrl.context.data
            );
        }

        this.transferDataForPaginatedTable =
            this.convertTransferDataForPaginatedTable();
    }

    public convertTransferDataForPaginatedTable(): any[] {
        let result: any[] = [];

        this.wizardCtrl.context.transferData.forEach((transferData: any) => {
            transferData.products.forEach((product: any) => {
                result.push({
                    transferData: transferData,
                    product: product
                });
            });
        });

        return result;
    }

    public startAddCompetition() {
        this.editCompetition = true;
        this.competitionError = false;
        this.competitionErrorMessage = [];
        this.competition = {
            constraint: {
                value: null,
                unit: null
            },
            offerIds: []
        };
        // for (let product of this.transferDataForPaginatedTable) {
        //     this.competition.offerIds.add({ [product.product.offerId] : false });
        // }
    }

    public validateCompetition() {
        this.competitionError = false;
        this.competitionErrorMessage = [];

        if (!this.competition.constraint.value) {
            this.competition.constraint.value = 0;
        }

        if (this.competition.offerIds) {
            if (
                this.competition.constraint.value.length <= 0 ||
                this.competition.offerIds.length < 2 ||
                this.getTotalCompetitionCapacity() <=
                    this.competition.constraint.value
            ) {
                this.competitionError = true;

                if (this.competition.constraint.value.length <= 0) {
                    this.competitionErrorMessage.push(
                        'Please define a competition constraint'
                    );
                }
                if (
                    this.getTotalCompetitionCapacity() <=
                    this.competition.constraint.value
                ) {
                    this.competitionErrorMessage.push(
                        'The competition constraint exceeds the total amount of capacity in the competition situation.'
                    );
                }
                if (this.competition.offerIds.length < 2) {
                    this.competitionErrorMessage.push(
                        'Please define more than 1 product for a competition'
                    );
                }
                return false;
            } else {
                //delete first before adding edited competition
                this.competitionError = false;
                return true;
            }
        }
    }

    public getTotalCompetitionCapacity() {
        var totalCompetitionCapacity = 0;
        for (let offerId of this.competition.offerIds) {
            totalCompetitionCapacity +=
                1 *
                this.getProductSetAndProductByOfferId(offerId)[1].amount.value
                    .value;
        }
        return totalCompetitionCapacity;
    }

    public addCompetition(index) {
        if (this.validateCompetition()) {
            if (index > -1) {
                this.wizardCtrl.context.competitions.splice(index, 1);
            }
            //todo decide if add order update
            this.wizardCtrl.context.competitions.push(this.competition);
            this.competition = {} as any;
            this.editCompetitionIndex = undefined;
            this.editCompetition = false;
            this.editExistingCompetition = false;
        }
    }

    public deleteCompetition(index) {
        var keepGoing = true;
        angular.forEach(
            this.wizardCtrl.context.competitions,
            (competition, key) => {
                if (keepGoing) {
                    if (key == index) {
                        keepGoing = false;
                        this.wizardCtrl.context.competitions.splice(key, 1);
                    }
                }
            }
        );
    }

    public startEditCompetition(index) {
        this.editExistingCompetition = true;
        this.editCompetition = true;
        this.editCompetitionIndex = index;
        this.competition = this.wizardCtrl.context.competitions[index];
    }

    public getProductSetAndProductByOfferId(offerId) {
        //helper method for retrieving offer by offerId
        var looping = true;
        var retProd = {};
        if (looping) {
            angular.forEach(
                this.wizardCtrl.context.transferData,
                (productSet) => {
                    if (looping) {
                        angular.forEach(productSet.products, (product) => {
                            // console.log(product);
                            if (product.offerId == offerId) {
                                looping = false;
                                retProd = [productSet, product];
                            }
                        });
                    }
                }
            );
        }
        return retProd;
    }

    public validateCompetitionMatch(
        existingProductArray,
        newProductArray
    ): boolean {
        var existingProductSet = existingProductArray[0];
        var existingProduct = existingProductArray[1];
        var newProductSet = newProductArray[0];
        var newProduct = newProductArray[1];

        this.competitionMatchError = false;
        this.competitionMatchErrorMessage = [];

        //check runtimes
        if (
            existingProductSet.runtime.start != newProductSet.runtime.start ||
            existingProductSet.runtime.end != newProductSet.runtime.end
        ) {
            this.competitionMatchError = true;
            this.competitionMatchErrorMessage.push(
                'Please select only products with matching runtimes.'
            );
        }

        //check flow direction
        if (
            existingProductSet.networkPoint.direction !=
            newProductSet.networkPoint.direction
        ) {
            this.competitionMatchError = true;
            this.competitionMatchErrorMessage.push(
                'Please select only products with matching flow directions.'
            );
        }

        //check producttype
        if (existingProductSet.productType != newProductSet.productType) {
            this.competitionMatchError = true;
            this.competitionMatchErrorMessage.push(
                'Please select only products with matching product types.'
            );
        }

        //check flow unit
        // if (
        //     existingProduct.regulatedCapacityTariff.originalUnit.physicalUnit !=
        //     newProduct.regulatedCapacityTariff.originalUnit.physicalUnit
        // ) {
        //     this.competitionMatchError = true;
        //     this.competitionMatchErrorMessage.push(
        //         'Please select only products with matching flow units.'
        //     );
        // }

        //check different offer ids
        if (existingProduct.offerId == newProduct.offerId) {
            this.competitionMatchError = true;
            this.competitionMatchErrorMessage.push(
                'Please select only products with different offer ids.'
            );
        }

        //check slot if available
        if (existingProduct.slotId) {
            if (existingProduct.slotId != newProduct.slotId) {
                this.competitionMatchError = true;
                this.competitionMatchErrorMessage.push(
                    'Please select only products with matching slot numbers.'
                );
            }
        }

        //check rollover datasets if available
        if (
            existingProductSet.productType == 'DAY' &&
            newProductSet.productType == 'DAY'
        ) {
            //check rollover enabled
            if (
                existingProduct.rolloverDataSetEnabled !=
                newProduct.rolloverDataSetEnabled
            ) {
                this.competitionMatchError = true;
                this.competitionMatchErrorMessage.push(
                    'Please select only products with matching rollover dataset settings.'
                );
            } else {
                //if the number of datasets matches, do a side by side comparison of the respective runtimes
                if (existingProduct.rolloverDataSet) {
                    let keepGoing = true;
                    let index = 0;
                    for (let dataset of existingProduct.rolloverDataSet) {
                        if (keepGoing) {
                            if (
                                dataset.selected ==
                                newProduct.rolloverDataSet[index].selected
                            ) {
                                if (
                                    dataset.runtime.start !=
                                        newProduct.rolloverDataSet[index]
                                            .runtime.start ||
                                    dataset.runtime.end !=
                                        newProduct.rolloverDataSet[index]
                                            .runtime.end
                                ) {
                                    keepGoing = false;
                                    this.competitionMatchError = true;
                                    this.competitionMatchErrorMessage.push(
                                        'Please select only products with matching rollover dataset runtimes.'
                                    );
                                }
                            } else {
                                keepGoing = false;
                                this.competitionMatchError = true;
                                this.competitionMatchErrorMessage.push(
                                    'Please select only products with matching rollover dataset runtimes.'
                                );
                            }
                        }
                        index++;
                    }
                }
            }
        }

        if (this.competitionMatchErrorMessage.length > 0) {
            return false;
        }
        this.competitionMatchError = false;
        return true;
    }

    public addRemoveProductToCompetition(offerId) {
        var keepGoing = true;
        var i = 0;

        for (let offer of this.competition.offerIds) {
            if (keepGoing) {
                if (offer == offerId) {
                    keepGoing = false;
                    this.competition.offerIds.splice(i, 1);
                    this.competitionMatchError = false;
                    if (this.competition.offerIds.length == 0) {
                        this.competition.constraint.unit = null;
                    }
                }
            }
            i++;
        }

        if (keepGoing) {
            let valid: boolean = true;
            if (this.competition.offerIds.length > 0) {
                //This is not the first competition offer, apply additional checks
                valid = this.validateCompetitionMatch(
                    this.getProductSetAndProductByOfferId(
                        this.competition.offerIds[0]
                    ),
                    this.getProductSetAndProductByOfferId(offerId)
                );
            } else {
                this.competitionMatchError = false;
                this.competitionMatchErrorMessage = [];
            }

            this.competition.offerIds.push(offerId);
            this.competition.constraint.unit =
                this.getProductSetAndProductByOfferId(
                    this.competition.offerIds[0]
                )[1].regulatedCapacityTariff.originalUnit.physicalUnit;

            if (!valid) {
                this.competition.offerIds.splice(
                    this.competition.offerIds.length - 1,
                    1
                );
            }
        }
    }

    public removeOfferIdFromExisitingCompetitions(offerId) {
        var i = 0;
        angular.forEach(this.wizardCtrl.context.competitions, (competition) => {
            var index = competition.offerIds.indexOf(offerId);
            if (index > -1) {
                competition.offerIds.splice(index, 1);

                if (competition.offerIds.length <= 1) {
                    this.wizardCtrl.context.competitions.splice(i, 1);
                }
            }
            i++;
        });
    }

    public filterOfferId(offerId, index) {
        return (
            this.wizardCtrl.context.competitions[index].offerIds.indexOf(
                offerId
            ) >= 0
        );
    }

    public deleteProductSet(guid) {
        for (
            var i = this.wizardCtrl.context.transferData.length - 1;
            i >= 0;
            i--
        ) {
            if (this.wizardCtrl.context.transferData[i].wizardGuid === guid) {
                this.wizardCtrl.context.transferData.splice(i, 1);
                break;
            }
        }
    }

    public deleteProduct(offerId, guid) {
        //ToDo: Check for length and remove transfer data object from step

        for (
            var i = this.wizardCtrl.context.transferData.length - 1;
            i >= 0;
            i--
        ) {
            var productSet = this.wizardCtrl.context.transferData[i];
            if (productSet.wizardGuid == guid) {
                for (var j = productSet.products.length - 1; j >= 0; j--) {
                    var product = productSet.products[j];
                    if (product.offerId == offerId) {
                        productSet.products.splice(j, 1);
                        this.removeOfferIdFromExisitingCompetitions(offerId);
                    }
                    if (productSet.products.length <= 0) {
                        this.wizardCtrl.context.transferData.splice(i, 1);
                    }
                }
            }
            if (this.wizardCtrl.context.transferData.length <= 0) {
                this.copyAddProductSet('add');
            }
        }
        this.transferDataForPaginatedTable =
            this.convertTransferDataForPaginatedTable();
    }

    public editProduct(wizardGuid) {
        this.wizardCtrl.context.data =
            this.wizardCtrl.context.transferData.find(
                (td) => td.wizardGuid === wizardGuid
            );
        this.wizardCtrl.goTo(1);
    }

    public isNewProductSet(guid) {
        let result = this.wizardCtrl.context.transferData.filter(
            (item) => item.wizardGuid == guid
        );
        return result.length === 0;
    }

    public competitionPossible() {
        var count = 0;
        angular.forEach(
            this.wizardCtrl.context.transferData,
            (transferData) => {
                angular.forEach(transferData.products, (product) => {
                    if (product != null) {
                        count++;
                    }
                });
            }
        );
        return count >= 2;
    }

    public copyAddProductSet(mode) {
        if (mode === 'add') {
            this.wizardCtrl.context.data = {};
            this.wizardCtrl.context.data.wizardGuid =
                this.utilService.generateGuid();
            this.wizardCtrl.goTo(0);
        } else if (mode === 'copy') {
            this.wizardCtrl.context.data = this.removeOfferIdsFromProducts(
                angular.copy(this.wizardCtrl.context.data)
            );
            this.wizardCtrl.context.data.wizardGuid =
                this.utilService.generateGuid();
            this.wizardCtrl.goTo(1);
        }
    }

    //helper method for removing offer IDs from stage data
    public removeOfferIdsFromProducts(data) {
        angular.forEach(data.products, (product) => {
            product.offerId = '';
        });
        return data;
    }

    @bind
    public toggleDetails() {
        this.wizardCtrl.context.data.errorDetailsShow =
            !this.wizardCtrl.context.data.errorDetailsShow;
    }

    public downloadXml() {
        var payload = this.productUploadWizardService.getMappedData({
            transferData: this.wizardCtrl.context.transferData,
            competitions: this.wizardCtrl.context.competitions
        });
        this.productResource.generateXml(payload, (res) => {
            this.fileService.triggerFileDownload(
                res.responseXml,
                'upload.xml',
                'text/xml'
            );
        });
    }

    public downloadResponse() {
        if (this.wizardCtrl.context.data.uploadSuccessful) {
            this.fileService.triggerFileDownload(
                this.wizardCtrl.context.data.successDetails,
                'response.xml',
                'text/xml'
            );
        }
    }

    public submit(isValid: boolean) {
        if (!isValid) {
            return false;
        }

        //reset previous errors and success messages
        this.wizardCtrl.context.data.uploadSuccessful = false;
        this.wizardCtrl.context.data.successMessage = '';
        this.wizardCtrl.context.data.successDetails = '';
        this.wizardCtrl.context.data.errorMessage = '';
        this.wizardCtrl.context.data.errorDetails = [];

        let mappedData = this.productUploadWizardService.getMappedData({
            transferData: this.wizardCtrl.context.transferData,
            competitions: this.wizardCtrl.context.competitions
        });

        this.productResource.save(
            mappedData,
            (res) => {
                this.wizardCtrl.context.data.uploadSuccessful = true;
                this.wizardCtrl.context.data.successMessage =
                    'The product upload succeeded.';
                this.wizardCtrl.context.data.successDetails = res.responseXml;
                this.wizardCtrl.finish();
                if (this.wizardCtrl.context.data.isEditMode) {
                    this.$window.history.back();
                }
            },
            (error) => {
                if (!!error.data.message) {
                    var errorMsg = error.data.message;
                    if (~errorMsg.indexOf('ValidationError|')) {
                        this.wizardCtrl.context.data.errorMessage =
                            'The validation of the uploaded product data failed!';
                        this.wizardCtrl.context.data.errorDetails =
                            errorMsg.split('|');
                        this.wizardCtrl.context.data.errorDetails.splice(0, 1);
                    } else {
                        this.wizardCtrl.context.data.errorMessage =
                            'The product upload failed!';
                        this.wizardCtrl.context.data.errorDetails.push(
                            errorMsg
                        );
                    }
                }
            }
        );
    }
}

angular.module('app').component('pkpProductUploadWizardSummary', {
    controller: ProductUploadWizardSummaryComponentCtrl,
    require: {
        wizardCtrl: '^^wizard'
    },
    template:
        require('app/product-upload-wizard/product-upload-wizard-summary.component.html'),
    bindings: {}
});
